import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withIntl } from 'ha/i18n';
import { toggleMobileMap, toggleMapAutoSearch } from 'ha/pages/Search/actions';
import ToggleMobileMap from '../components/ToggleMobileMap';

const enhance = compose(
  withIntl,
  connect(null, {
    toggleMobileMap,
    toggleMapAutoSearch,
  }),
);

export default enhance(ToggleMobileMap);
